const state = {
  tabIndex: 0
}

const getters = {}

const mutations = {
  SET_CURRENT_TAB_INDEX: (state, payload) => {
    state.tabIndex = payload
  }
}

const actions = {
  setCurrentTabIndex({ commit }, currentTabIndex) {
    commit('SET_CURRENT_TAB_INDEX', currentTabIndex)
  },
  clearTabIndex({ commit }) {
    commit('SET_CURRENT_TAB_INDEX', 0)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
